module.exports = __webpack_public_path__ + "img/moving-in.88538569.png";